import styled from '@emotion/styled';

const Section = styled.section`
	background: white;
	padding: 2rem 1.5rem 3rem;
`;

const Inner = styled.div`
	max-width: 72rem;
	margin: 0 auto;
`;

const Body = styled.div`
	font-size: 1.125rem;
	line-height: 1.9rem;
`;

export default function WysiwygBlockAlpha({ description }: { description: string }) {
	return (
		<Section id="description">
			<Inner>
				<Body>{description}</Body>
			</Inner>
		</Section>
	);
}
